module.exports = require('./helpers/bundle-url').getBundleURL('9nzY3') + "logo.c51670a8.svg";